<template>
  <section class="nft h-screen bg-black overflow-hidden">
    <div class="bg-black h-screen overflow-hidden relative">
      <!--  <section class="nft bg-black">-->
      <!--    <div class="bg-black relative">-->
      <div
          class="absolute left-0 w-full bg-black bt-gradient py-20 lg:py-100-vw my-0 blex nft-card h-screen "
          v-for="(card, index) in cards"
          :key="index"
          :class="`nc-${index}`"
      >
        <div class="w-full lg:w-4/5-vw blex lg:blex-between items-start lg:flex-no-wrap">
          <!-- desktop     -->
          <div class="relative lg:block hidden">
            <!--bg circle-->
            <img src="@/assets/images/pages/main/nft/nftCircle.svg" class="bg-circle">

            <!--nft collection 사진-->
            <div class="item"
                 v-if="card.status !== 'isSlider'">
              <img :src="card.collection_img" class="blex w-full">
            </div>
            <!--@todo :  nft collection 아바타 슬라이더-->
            <div v-else class="item">
              <hooper
                  :itemsToShow="1"
                  :centerMode="true"
                  pagination="no"
                  style="height: 100%"
                  :infiniteScroll="true"
                  :autoPlay="true"
              >
                <slide>
                  <img src="@/assets/images/pages/main/nft/avatar.png" alt="" class="blex w-full">
                </slide>
                <slide>
                  <img src="@/assets/images/pages/main/nft/avatar4.png" alt="" class="blex w-full">
                </slide>
                <slide>
                  <img src="@/assets/images/pages/main/nft/avatar2.png" alt="" class="blex w-full">
                </slide>
                <slide>
                  <img src="@/assets/images/pages/main/nft/avatar3.png" alt="" class="blex w-full">
                </slide>
                <slide>
                  <img src="@/assets/images/pages/main/nft/avatar5.png" alt="" class="blex w-full">
                </slide>
                <slide>
                  <img src="@/assets/images/pages/main/nft/avatar6.png" alt="" class="blex w-full">
                </slide>
                <hooper-navigation slot="hooper-addons"></hooper-navigation>
              </hooper>
            </div>
          </div>

          <!--nft collection 글-->
          <div class="blex lg:blex-y-between lg:justify-start px-16 lg:pr-0 lg:pl-160 h-screen lg:h-auto">

            <div class="blex-left bg-black w-full">
              <div class="text-white font-bold text-2xl lg:text-6xl-vw bottom-gradient pb-12 whitespace-no-wrap">
                NFT COLLECTION
              </div>
              <!--nft collection 번호-->
              <div class="text-white font-bold text-2xl lg:text-5xl-vw blex-left w-full pb-0 pt-8 lg:pt-30">
                {{ card.number }}
              </div>
            </div>

            <!-- mobile       -->
            <div class="relative block lg:hidden">
              <!--bg circle-->
              <img src="@/assets/images/pages/main/nft/nftCircle.svg" class="bg-circle">

              <!--nft collection 사진-->
              <div class="item"
                   v-if="card.status !== 'isSlider'"
              >
                <img :src="$store.state.windowWidth > 1024 ? card.collection_img : card.collection_img_m"
                     class="w-full">
              </div>
              <div v-else class="item">
                <hooper
                    :itemsToShow="1"
                    :centerMode="true"
                    pagination="no"
                    style="height: 100%;"
                    :infiniteScroll="true"
                    :autoPlay="true"
                >
                  <slide>
                    <img
                        :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/nft/avatar.png') : require('@/assets/images/pages/main/nft/mAvatar.png')"
                        alt="" class="blex w-full">
                  </slide>
                  <slide>
                    <img
                        :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/nft/avatar4.png') : require('@/assets/images/pages/main/nft/mAvatar4.png')"
                        alt="" class="blex w-full">
                  </slide>
                  <slide>
                    <img
                        :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/nft/avatar2.png') : require('@/assets/images/pages/main/nft/mAvatar2.png')"
                        alt="" class="blex w-full">
                  </slide>
                  <slide>
                    <img
                        :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/nft/avatar3.png') : require('@/assets/images/pages/main/nft/mAvatar3.png')"
                        alt="" class="blex w-full">
                  </slide>
                  <slide>
                    <img
                        :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/nft/avatar5.png') : require('@/assets/images/pages/main/nft/mAvatar5.png')"
                        alt="" class="blex w-full">
                  </slide>
                  <slide>
                    <img
                        :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/nft/avatar6.png') : require('@/assets/images/pages/main/nft/mAvatar6.png')"
                        alt="" class="blex w-full">
                  </slide>
                  <hooper-navigation slot="hooper-addons"></hooper-navigation>
                </hooper>
              </div>
            </div>

            <!-- description         -->
            <div class="blex-left w-full lg:w-auto pt-0 lg:pt-80">

              <!--nft collection 이름-->
              <div class="name">
                {{ $t(card.name) }}
                <div class="blex point">
                  <img src="@/assets/images/pages/main/nft/point.svg" class="lg:block hidden">
                  <img src="@/assets/images/pages/main/nft/mPoint.svg" class="block lg:hidden">
                </div>
              </div>

              <!--nft collection 설명-->
              <div class="text-white font-medium leading-2xs lg:leading-xs text-4xs lg:text-base py-20 w-full"
                   v-html="$t(card.detail)"></div>
              <!--          <div class="text-white font-medium leading-xs text-base w-full" v-html="detail2"></div>-->
            </div>

          </div>

        </div>
      </div>
    </div>

  </section>

</template>

<script>
// import NftCard from '@/views/components/nftCollection/NftCard'
import {Hooper, Slide, Navigation as HooperNavigation} from 'hooper'
import 'hooper/dist/hooper.css'

let timeline = null

export default {
  name: 'Nft',
  components: {
    Hooper,
    Slide,
    HooperNavigation
  },
  data: () => ({
    waitingChildrenCount: 0,
    cards: [
      {
        collection_img: require('@/assets/images/pages/main/nft/ride.png'),
        collection_img_m: require('@/assets/images/pages/main/nft/mRide.png'),
        number: '01',
        name: 'nft.title.1',
        detail: 'nft.1'
      },
      {
        collection_img: require('@/assets/images/pages/main/nft/animal2.png'),
        collection_img_m: require('@/assets/images/pages/main/nft/mAnimal.png'),
        number: '02',
        name: 'nft.title.2',
        detail: 'nft.2'
      },
      {
        collection_img: require('@/assets/images/pages/main/nft/land.png'),
        collection_img_m: require('@/assets/images/pages/main/nft/mLand.png'),
        number: '03',
        name: 'nft.title.3',
        detail: 'nft.3'
      },
      {
        collection_img: require('@/assets/images/pages/main/nft/sickle.png'),
        collection_img_m: require('@/assets/images/pages/main/nft/mSickle.png'),
        number: '04',
        name: 'nft.title.4',
        detail: 'nft.4'
      },
      {
        status: 'isSlider',
        number: '05',
        name: 'nft.title.5',
        detail: 'nft.5'
      }
    ],
    sliderIndex: 0
  }),
  watch: {},
  methods: {
    animations() {
      timeline = this.$gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          scroller: '#index',
          trigger: 'section.nft',
          start: 'top',
          end: '400%',
          pin: true,
          scrub: true,
          preventOverlaps: true,
          fastScrollEnd: true,
          toggleActions: 'restart none reverse none'
        }
      })

      const cards = this.$gsap.utils.toArray('.nft-card')
      cards.forEach((card, index) => {
        if (index > 0) {
          timeline.fromTo(card, {
            yPercent: 100
          }, {
            ease: 'linear',
            yPercent: 0,
            duration: 1
          })

          // timeline.to(card, {
          //   ease: 'linear',
          //   y: 0
          // })
        }
      })
    }
  },
  mounted() {
  },
  beforeDestroy() {
    if (timeline) {
      timeline.kill()
    }
  }
}
</script>

<style scoped lang="scss">
section::v-deep {
  .nft-card {
    .bg-circle {
      width: 32.813vw;
      height: 32.813vw;
      @media screen and (max-width: 1024px) {
        width: 250px;
        height: 250px;
      }
    }

    .item {
      position: absolute;
      width: 32.813vw;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-content: center;
      align-items: center;
      left: 0;
      top: 0;

      @media screen and (max-width: 1024px) {
        width: 100%;

      }

      .hooper-navigation {
        .hooper-prev {
          background: url("~@/assets/images/pages/main/nft/leftArrow.svg");
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;

          .icon-arrowLeft {
            display: none;
          }
        }

        .hooper-next {
          background: url("~@/assets/images/pages/main/nft/rightArrow.svg");
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;

          .icon-arrowRight {
            display: none;
          }
        }

      }

    }


    .name {
      display: flex;
      justify-content: center;
      align-items: center;
      width: auto;
      color: #fff;
      font-weight: 600;
      padding: 12px 30px;
      border: 1px solid #c7c7c7;
      position: relative;
      font-size: 1.875vw;

      @media screen and (max-width: 1024px) {
        width: auto;
        padding: 6px 15px;
        font-size: 13px;
      }

      .point {
        position: absolute;
        top: 0;
        left: 0;
        transform: translate(-100%, -100%);
        @media screen and (max-width: 1024px) {
          transform: translate(-3%, -100%);
        }
      }
    }
  }
}

</style>
